import './App.css';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import HomePage from './Components/HomePage';
import CharacterDesgin from './Components/CharaterDesign';
import Backgrounds from './Components/Backgrounds'
import ConceptArt from './Components/ConceptArt';
import ShortFilm from './Components/ShortFilm';
import Illustration from './Components/Illustration';
import Material from './Components/MaterialStudy';
import LWT from './Components/LetsWork';
import Rough from './Components/RoughAnimation';


const page = [<HomePage/>]

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={page}/>
          <Route path='/Character-Design' element={<CharacterDesgin/>} />
          <Route path='/ConceptArt' element={<ConceptArt/>} />
          <Route path='/Backgrounds' element={<Backgrounds/>} />
          <Route path='/ShortFilm' element={<ShortFilm/>} />
          <Route path='/Illustration' element={<Illustration/>} />
          <Route path='/MaterialStudy' element={<Material/>} />
          <Route path='/LetsWorkTogether' element={<LWT/>} />
          <Route path='/RoughAnimation' element={<Rough/>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
